module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapTitle1"
  }, [_c('a', {
    attrs: {
      "id": "HLD1"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Like so many quilters, I find inspiration for quilt designs wherever I go. The side of a building, a stack of dishes in the cupboard—everything seems to have the potential to be a beautiful quilt block.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("I also love fabric—prints and solids, brights and neutrals. It often seems like I have more fabric than I will ever be able to turn into projects!")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("It was this feeling of being overwhelmed by possibility that led me to write a book of sampler quilts.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The 75 blocks in this book were inspired by the places and everyday objects I see around me. As I built more and more blocks, they became a kind of patchwork city—a reflection of the shapes, colors, and fabrics I love.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Making a sampler quilt is a long-term project, and I encourage you to embrace that fact. We all have projects that need to be completed on a deadline, but this should not be one of them. Embrace the idea of making a quilt that is for you and is a reflection of your favorite things. Consider each block as its own composition and take the time to choose fabric thoughtfully. It will take as long as it needs to. Build your very own patchwork city!")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "HLD2"
    }
  }), _vm._v("What Is a Sampler Quilt?")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A sampler quilt includes one each of a variety of blocks, rather than a single block repeated across the entire quilt. Quilters have historically made samplers to practice and display a variety of skills.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "HLD3"
    }
  }), _vm._v("About This Book")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('i', [_vm._v("Patchwork City")]), _vm._v(" includes 75 block patterns: 25 each in three sizes (8˝ × 8˝, 5˝ × 8˝, and 5˝ × 14˝). The instructions for each block are written as individual projects, making them perfect for using scrap fabric. Don’t hesitate to skip around in the book to mix and match your favorites!")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("I’ve also included six projects that allow you to combine the blocks to make sampler quilts. Each of the quilt projects includes yardage requirements for sashing, backing, and binding.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The "), _c('span', {
    attrs: {
      "href": "#/89_chapter85#pg_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How-To chapter")]), _vm._v(" includes the basics of making the blocks. More in-depth information about how to sandwich, quilt, and bind your project can be found in my other books, "), _c('i', [_vm._v("The Practical Guide to Patchwork")]), _vm._v(" and "), _c('i', [_vm._v("Modern Patchwork")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "pg_6"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dbaf46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_chapter01.vue
// module id = 66
// module chunks = 0